import { Component, HostListener, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarHandler } from 'src/app/other/open-snack-bar';
import { AUTHGWCONSTANTS } from '../authconstatnts';
import { SigninService } from './signin.service';
import { AppService } from 'src/app/app.service';
import { StaticMemory } from 'src/app/handler/static_memory';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OtpComponent } from '../otp/otp.component';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss'],
    standalone: false
})
export class SigninComponent implements OnInit {
  data: any = {};
  loading: boolean = true;
  loggedIn: boolean = false;
  isLoading: boolean = false;
  imgSrc: string = '';

  heroRows: string[][] = [];
  categoryArray: any[] = [];
  subCategoryArray: any[] = [];
  logoSrc: string = '';
  isPhoneValid: boolean = false;

  constructor(
    private snackbar: SnackBarHandler,
    private router: Router,
    private service: SigninService,
    private appService: AppService,
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<SigninComponent>,
    private signinService: SigninService
  ) {
    this.data.phoneNumber = '';
    this.imgSrc = 'assets/images/background_jompoi.jpg';
    this.logoSrc = StaticMemory.businessProfileObject?.primaryLogoLink;
  }

  ngOnInit(): void {
    this.getParentCategories();
    setTimeout(() => {
      this.loading = false;
    }, 300);
    this.checkAndRedirectForDesktop();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.checkAndRedirectForDesktop();
  }

  private checkAndRedirectForDesktop(): void {
    if (typeof window === 'undefined' || this.dialogRef) {
      return;
    }

    const width = window.innerWidth;
    if (width >= 900) {
      this.router.navigate(['/']);
    }
  }

  getParentCategories(): void {
    this.appService.getParentCategories().subscribe((success) => {
      if (success.status && success.result && success.result.length) {
        this.categoryArray = success.result;
        const allCategory = success.result.find(
          (cat: any) => (cat.categoryName || '').toLowerCase() === 'all',
        );

        if (allCategory) {
          this.subCategoryArray = allCategory.subCategoriesInfo || [];
          const heroImages: string[] = this.subCategoryArray
            .map((sub: any) => sub?.image?.link)
            .filter((url: string) => !!url);
          const perRow = 4;
          this.heroRows = [];
          for (let i = 0; i < heroImages.length; i += perRow) {
            this.heroRows.push(heroImages.slice(i, i + perRow));
          }
        }
      }
    });
  }

  onNext(): void {
    if (this.isValid()) {
      const body = {
        method: 0,
        dialCode: 91,
        applicationId: environment.applicationId,
        phoneNumber: Number(this.data.phoneNumber),
      };
      this.isLoading = true;
      sessionStorage.setItem('sign-object', JSON.stringify(body));

      this.service.postSignIn(body).subscribe(
        (success) => {
          if (success.code === 4210) {
            if (this.dialogRef) {
              this.dialogRef.close();
            }
            this.router.navigate(['auth/signup']);
          } else if (success.status && success.result && success.result.length) {
            localStorage.setItem(AUTHGWCONSTANTS.hash, success.result[0]);

            const width = typeof window !== 'undefined' ? window.innerWidth : 0;
            const isDesktop = width >= 900;
            const isHome = this.router.url === '/' || this.router.url.startsWith('/?');

            if (isDesktop && isHome) {
              if (this.dialogRef) {
                this.dialogRef.close();
              }
              this.service.otpState$.next('open');
              this.dialog.open(OtpComponent, {
                panelClass: 'signin-dialog',
                width: '480px',
                maxWidth: '90vw',
                autoFocus: false,
                disableClose: false,
              });
            } else {
              if (this.dialogRef) {
                this.service.otpState$.next('close');
                this.dialogRef.close();
              }
              this.router.navigate(['/auth/otp']);
            }
          } else {
            this.snackbar.openErrorSnackBar(success.message);
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        },
        (error) => {
          this.snackbar.openErrorSnackBar('HTTP ERROR IN POST SIGN IN');
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        },
      );
    }
  }

  onSignup(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.router.navigate(['auth/signup']);
  }

  isValid(): boolean {
    if (!this.isPhoneValid) {
      this.snackbar.openErrorSnackBar('Enter valid phone number');
      return false;
    }
    return true;
  }

  isMobValid(): void {
    let phone = this.data.phoneNumber;
    if (phone != null) {
      if (phone > 9999999999) {
        phone = phone.toString().substring(0, 10);
        this.data.phoneNumber = parseFloat(phone);
      }
      this.isPhoneValid = this.data.phoneNumber && this.data.phoneNumber.toString().length === 10;
    }
  }
}
